import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    // =========================================================================
    // 1. META PIXEL / TRACKING INITIALIZATION
    // =========================================================================
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')(window as any).fbq('init', '28914431981489824')
    // 3. PAGE VIEW OPTIMIZATION (Fires immediately on load)
;
    (window as any).fbq('track', 'PageView')
    // 4. VIEW CONTENT EVENT (Specific product tracking)
;
    (window as any).fbq('track', 'ViewContent', {
      content_name: 'The Midnight Magnet Protocol',
      content_category: 'Digital Product / Manifestation',
      content_ids: ['MM-001'],
      content_type: 'product',
      value: 6.37,
      currency: 'USD'
    });
    // =========================================================================
  }, []);
  return <SalesPage data-id="element-0" />;
}